<template>
  <div>
    <p style="text-align=center;">
      <span class="systemFont0">{{ $t("p0101.userStatistics") }}</span>
    </p>
    <p>
      <label class="systemFont1" style="color:#224268">{{
        $t("p0101.registrationNumbers")
      }}</label
      ><label class="systemFont0" style="color:#224268">{{
        this.userForm.registrationNumber
      }}</label>
    </p>
    <el-form
      ref="form"
      :model="userForm"
      label-width="80px"
      class="systemFont1"
    >
      <div>
        <el-row style="top: 17px">
          <el-col :span="22" :offset="1">
            <div class="mar">
              <!-- <el-form-item> -->
              <el-date-picker
                :editable='false'
                :clearable='false'
                v-model="userForm.years"
                type="year"
                placeholder="选择年"
                style="width: 120px;"
                :picker-options="pickerOptions"
                @change="change"
                format="yyyy"
                value-format="yyyy"
              >
                <!-- <el-date-picker
                v-model="userForm.years"
                value-format="yyyy"
                format="yyyy"
                type="year"
                style="width: 100px"
                placeholder="选择年"
                :picker-options="pickerOptions"
                @change="change"
              > -->
              </el-date-picker>
              <!-- </el-form-item> -->
            </div>
            <el-table
              :data="userForm.userNumList"
              style="width: 100%; margin-bottom: 75px"
              :header-cell-style="{ textAlign: 'center' }"
              :cell-style="{ textAlign: 'center' }"
            >
              <el-table-column
                prop="month"
                :label="$t('p0101.month')"
                min-width="4"
              >
              </el-table-column>
              <el-table-column
                prop="userNumber"
                :label="$t('p0101.curMonthUserNums')"
                min-width="4"
              >
              </el-table-column>
              <el-table-column
                prop="managerNumber"
                :label="$t('p0101.curMonthAdminNums')"
                min-width="4"
              >
              </el-table-column>
              <el-table-column
                prop="total"
                :label="$t('p0101.cumMonthNumbers')"
                min-width="4"
              >
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </div>
    </el-form>
  </div>
</template>

<script>
import qs from "qs";
export default {
  data() {
    let _that = this;
    return {
      userForm: {
        // 个人用户注册数量
        registrationNumber: "",
        // 年份
        years: new Date().toISOString().substring(0, 4),
        // 表
        userNumList: []
      },
      yearsList: [],
      pickerOptions: {
        disabledDate(time) {
          return !_that.yearsList.includes(time.getFullYear());
        }
      }
    };
  },

  mounted() {
    // 获取画面数据
    this.getUserNumber();
    // 获取年份范围
    this.getYearScope();
  },
  methods: {
    //可选择年份范围
    getYearScope() {
      let url = "/api/useMonitoring/getYearScope";
      // 访问对应后端的api获取画面数据
      this.$http
        .get(url)
        .then(response => {
          this.response = JSON.stringify(response.data);
          // this.userForm = response.data();
          if (response.data.code === 200) {
            console.log("response.data" + this.response);
            this.yearsList = response.data.data;
            console.log(this.yearsList);
          } else {
            this.$message.error(response.data.message);
          }
        })
        .catch(err => {
          console.log(err);
          this.$message({
            message: "查询失败！",
            type: "error"
          });
        });
    },
    //年份改变时
    change() {
      this.getUserNumber();
    },
    // 获取注册用户统计画面信息
    getUserNumber() {
      const loading = this.$loading({
        lock: true,
        text: this.$t("common.loading"),
        background: "rgba(255,255,255,0.8)",
        target: document.querySelector("#main-container")
      });
      // let url = "/api/useMonitoring/getUserNumber";
      let url = "/api/useMonitoring/getUserNumber";
      // 访问对应后端的api获取画面数据
      this.$http
        .post(
          url,
          qs.stringify({
            years: this.userForm.years,
            registrationNumber: this.userForm.registrationNumber
          })
        )
        .then(response => {
          this.response = JSON.stringify(response.data);
          // this.userForm = response.data();
          if (response.data.code === 200) {
            console.log("response.data" + this.response);
            this.userForm = response.data.data;
          } else {
            loading.close();
            this.$message.error(response.data.message);
          }
          // console.log("response.data"+this.response)
          // this.userForm=response.data.data
          loading.close();
        })
        .catch(err => {
          loading.close();
          console.log(err);
          this.$message({
            message: "查询失败！",
            type: "error"
          });
        });
    }
  }
};
</script>

<style lang="scss" scoped>
>>> .mar {
  text-align: left;
}
>>> .itemStyleTop {
  text-align: left;
}
>>> .el-table {
  white-space: pre-wrap;
}
// >>> .el-table td.el-table__cell {
//   white-space: pre-line;
// }
>>> .el-table thead {
  font-family: "Arial Negreta", "Arial Normal", "Arial";
  color: #333333;
  font-size: 16px;
}

>>> .el-table__header {
  border-bottom: 3px solid rgb(170, 170, 170);
}

>>> .el-table__row {
  height: 42px;
}
// >>> .el-input--systemFormDate.el-input__inner {
//   height: 20px;
//   border-color: rgb(204, 204, 204);
// }

>>> .el-table td.el-table__cell,
.el-table th.el-table__cell.is-leaf {
  border-bottom: 0.5px solid rgb(170, 170, 170);
}

>>> .el-table--border::after,
.el-table--group::after,
.el-table::before {
  background: none;
}
</style>



// WEBPACK FOOTER //
// src/views/UseMonitoring/P0101.vue